/**
 * Persistent disclaimer for the Ask page. Always visible. Not modal.
 */
export function AskDisclaimer() {
  return (
    <p
      role="note"
      className="text-xs leading-relaxed text-ink-500 dark:text-ink-400 max-w-prose"
    >
      Alhudah Ask is a Quran study tool grounded in retrieved verses and
      translations. It is not a substitute for scholarly tafsir, fatwa, or
      personal religious guidance.
    </p>
  );
}
